<template>
    <table class="cart-table__table">
        <thead class="cart-table__head">
            <tr class="cart-table__row">
                <th class="cart-table__column cart-table__column--image">Item Number</th>
                <th class="cart-table__column cart-table__column--numeral">Quantity</th>
                <th class="cart-table__column cart-table__column---order-entry-mfg">MFG Code</th>
                <th class="cart-table__column cart-table__column--product">Item Validation</th>
                <th class="cart-table__column cart-table__column--numeral">Approved</th>
                <th class="cart-table__column cart-table__column--numeral">Item Credit</th>
                <th class="cart-table__column cart-table__column--numeral">Core Credit</th>
                <th class="cart-table__column cart-table__column--numeral">Ext Credit</th>
                <th class="cart-table__column cart-table__column--remove">
                    <!-- <img src="images/spacer.png" width="20px" /> -->
                </th>
            </tr>
        </thead>
        <tbody class="cart-table__body">
            <list-item v-for="(part, index) in parts"
                :ref="setItemRef"
                :key="index"
                :part="part"
                :dparts="duplicates(part)"
                :index="index"
                :locations="locations"
                @update_qty="update_qty"
                @update_item_code="changeItemCode"
                @update_mfg_code="changeMFGCode"
                @remove_item="remove_item"
            >
            </list-item>
        </tbody>
        <tfoot class="cart-table__foot">
            <tr>
                <td colspan="12">
                    <div class="cart-table__actions">
                        <div class="form-row">
                            <div class="form-group">
                                
                            </div>
                            <div class="form-group col-md-6">
                                <label for="checkout-first-name">Email Confirmation</label>
                                <input type="text" class="form-control" id="checkout-billing-first-name" placeholder="" v-model="email" @change="$emit('update_email', email)"/>
                            </div>
                            <div class="form-group col-md-6">
                                <label for="checkout-last-name">Purchase Reference #</label>
                                <input type="text" class="form-control" id="checkout-billing-last-name" placeholder=""              />
                            </div>
                            <!-- <div class="form-group col-md-3">
                                <label for="checkout-last-name">PO Number</label>
                                <input type="text" class="form-control" id="checkout-billing-last-name" placeholder="" v-model="retPO" @change="$emit('update_po', retPO)" />
                            </div> -->
                        </div>
                    </div>
                </td>
            </tr>
            <tr>
                <td colspan="6">
                    <div class="cart-table__actions">
                        <div class="cart-table__update-button cart-table__actions-stock-order-add-to-cart">
                            <button class="btn btn-md btn-checkout mr-2" :disabled="btnSubmitEnable" @click="$emit('submit')">Submit Return Request</button>
                            <!-- <button class="btn btn-md btn-checkout" :disabled="btnSaveEnable"  @click="$emit('save_list')">Save</button> -->
                        </div>
                    </div>
                </td>
            </tr>
        </tfoot>
    </table>
</template>

<script>
import ListItem from './ListItem';

export default {
    name: 'ReturnItemsList',
    components: {ListItem},
    props: {
        dparts: {
            type: Array
        },
        parts: {
            type: Array
        },
        allValid: {
            type: Boolean
        },
        btnSubmitEnable: {
            type: String
        },
        btnSaveEnable: {
            type: String
        },
    },
    watch: {
        btnSaveEnable(newVal) {
            console.log(newVal);
        }  
    },
    computed: {
        
    },
    data() {
        return {
            // btnSubmitEnable: 'disabled',
            // btnSaveEnable: 'disabled',

            email: '',
            retPO: '',
            referenceNo: '',

            trows: [],
        };
    },
    methods: {
        duplicates(part){
            const dups = this.dparts.filter( d => d.EIITMC == part.item);
            return dups;
        },

        /**
         * validate parts from the list
         */
        validate() {
            this.isloading = true;
            const paramParts = [];
            
            this.parts.forEach(p => {
                if(p.item != null && p.item != ''){
                    paramParts.push([
                        p.item,
                        p.manufacturer
                    ]);
                } 
            });

           console.log(paramParts);
        },
        remove_item(index){
            this.$emit('remove_item', index);
        },
        update_qty(index, newQty){
            this.$emit('update_qty', index, newQty);
        },

        changeItemCode(index, newVal){
            this.$emit('update_item_code', index, newVal);
        },

        changeMFGCode(index, newVal){
            this.$emit('update_mfg_code', index, newVal);
        },

        loadTable(){
            // console.log(this.parts);
            // eslint-disable-next-line no-undef
            this.parts.forEach((p,i) => {   
                // console.log(this.trows[i]);
                this.trows[i].updateRow(p.item, p.quantity);
            });
        },

        setItemRef(el) {
            if (el) {
                this.trows.push(el)
            }
        }
    },

    mounted() {
        // console.log(this.parts);
        if(this.$route.params.saved != ''){
            // this.referenceNo = this.$route.params.saved;
        }
        this.email = this.$store.getters['cart/email'].toLowerCase();
    }
}
</script>